import { render } from "./SnackbarQueue.vue?vue&type=template&id=502688fa&ts=true"
import script from "./SnackbarQueue.vue?vue&type=script&lang=ts"
export * from "./SnackbarQueue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__